import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import {
  SUBSCRIPTION_DELETE,
  SUBSCRIPTION_LIST,
} from "../../../services/ApiCalls";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import { AdminStatusOptionSubscription } from "../../../utilities/const";
import Filter from "../../../components/Common/Filter";

const ManageSubscription = () => {
  const roleData = JSON.parse(localStorage.getItem("roleDetail"));
  const permissions = roleData?.permissions[0] || {};
  const role = localStorage.getItem("role");
  const {
    body,
    searchHandler,
    deleteHandler,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    total,
    loader,
    data,
    setBody,
  } = dataHandler({
    api: SUBSCRIPTION_LIST,
    // dataToSet: (data) => data,
  });
  const column = [
    {
      head: "Plan Name",
      accessor: "description",
      component: (item) => <>{item.name}</>,
    },
    {
      head: "Description",
      accessor: "description",
      component: (item) => <>{item.description}</>,
    },
    {
      head: "Price",
      accessor: "price",
      component: (item) => {
        return <>{item?.price != null ? `$ ${item.price}` : "----"}</>;
      },
    },
    {
      head: "Start Date ",
      accessor: "validity",
      component: (item) => <>{moment(item?.start_date).format("DD-MM-YYYY")}</>,
    },
    {
      head: "End Date ",
      accessor: "validity",
      component: (item) => (
        <>{moment(item?.date_expires).format("DD-MM-YYYY")}</>
      ),
    },
    {
      head: "Status",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <p
          className={`${
            item.status === "false" || item.status === "inactive"
              ? "redStatus"
              : item.status == "true" || item.status === "active"
              ? "greenStatus"
              : ""
          } status m-0 rounded-pill px-3 text-capitalize py-1 fw-sbold`}
        >
          {item.status === "true" || item?.status === "active"
            ? "Active"
            : "InActive"}
        </p>
      ),
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <TableActions
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
          editUrl={`/subscription/edit/${item?._id}`}
          // viewLink={`/subscription/view/${item?._id}`}
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel?.show}
        setConfirmation={() =>
          setDeleteModel((p) => ({ show: false, dumpId: "" }))
        }
        confirmHandler={() => {
          deleteHandler(() => SUBSCRIPTION_DELETE(deleteModel.dumpId));
        }}
      />
      <section className="ManageTeacher position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center justify-content-between gap-10">
                <h4 className="mb-0 py-3 fw-bold text-capitalize text-primary">
                  Manage Subscription
                </h4>

                <Link
                  to={"/subscription/add"}
                  className="btn btn-primary d-flex align-items-center fw-sbold justify-content-center commonBtn"
                >
                  Add New Subscription
                </Link>
              </div>
            </Col>
            <Row className="pl-4">
              <Filter
                body={body}
                searchHandler={searchHandler}
                setBody={setBody}
                statusFilterOptionArr={AdminStatusOptionSubscription}
              />
            </Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <TableLayout data={data} column={column} loader={loader} />
                <CustomPagination
                  body={body}
                  setBody={setBody}
                  pageChangeHandler={paginationHandler}
                  total={total}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageSubscription;
